// store/subnetSlice.ts
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchSubnetList, SubnetData } from "@/api";

export const fetchSubnets = createAsyncThunk(
  "subnet/fetchSubnets",
  async (time: string) => {
    const data = await fetchSubnetList(time);
    return data;
  }
);

const subnetSlice = createSlice({
  name: "subnet",
  initialState: {
    data: [] as SubnetData[],
    loading: false,
    error: null as string | null,
  },
  reducers: {
    setData: (state, action: PayloadAction<SubnetData[]>) => {
      state.data = action.payload;
      console.log("setData called with:", action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubnets.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSubnets.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchSubnets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Fetch failed";
      });
  },
});

export const { setData } = subnetSlice.actions;
export default subnetSlice.reducer;
